import React from 'react';
import { Box } from '@mui/material';
import { AppPanelShell } from '../components/layout/AppPanelShell';
import { useWalletAccount } from '../features/wallet/hooks/useWalletAccount';
import { useCwyTransferRequests } from '../features/wallet/hooks/useCwyTransferRequests';
import { CwyActivityLedger } from '../features/wallet/components/CwyActivityLedger';
import { CwyTransferProgressCard } from '../features/wallet/components/CwyTransferProgressCard';

export const TransactionsPage: React.FC = () => {
  const wallet = useWalletAccount();
  const hasSavedWallet = Boolean(wallet.primaryWallet?.address);
  const transfers = useCwyTransferRequests(hasSavedWallet);

  return (
    <AppPanelShell title="Transaction History">
      <Box sx={{ px: 2, py: 2 }}>
        {transfers.progressRequest && (
          <CwyTransferProgressCard request={transfers.progressRequest} />
        )}
        <CwyActivityLedger requests={transfers.requests} />
      </Box>
    </AppPanelShell>
  );
};
